import { Md5 } from 'md5-typescript';
import { DesignData } from 'views/StudioSearchProductPage/types';

// eslint-disable-next-line import/prefer-default-export
export const getDesignContentHash = (structure: DesignData) => Md5.init(structure);
